// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"292d0166","588":"dbb06a70","961":"6d769729","970":"1f7bac40"}[chunkId] + ".chunk.css";
};